import { render, staticRenderFns } from "./StructurePanelDropdownMenu.vue?vue&type=template&id=d6cbabf2&"
import script from "./StructurePanelDropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./StructurePanelDropdownMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports